import { transport } from 'config/transport';

export function callApiGetCTPVReportForAllCongDoan(academicYear) {
    return transport.get(`/trunguong/congtacphucvu/thuchi`, { params: { academicYear } });
}
